import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { LegalRolandStepParams } from './types'
import { insuredPartiesSchema } from './types'

export const insuredParties = (params: LegalRolandStepParams) => {
  const schema = insuredPartiesSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_roland.insured_parties.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_legal_roland_de.shape.configuration_parameters.shape.insured_parties.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_legal:steps.legal_roland.insured_parties.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('insured_parties'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'previous_insurance_got_canceled',
    subFlow: SubFlow.LegalRoland,
  } as const satisfies AnyStepConfiguration
}
